import { render, staticRenderFns } from "./HelpTermStore.vue?vue&type=template&id=57b8aaf0"
import script from "./HelpTermStore.vue?vue&type=script&lang=js"
export * from "./HelpTermStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports